<template>
  <draggable-dialog
    v-model:visible="visible"
    title=""
    width="1000"
    top="6vh"
    draggable
    modal-class="video-dialog-txy-778yyy"
    destroy-on-close
    :close-on-click-modal="false"
    :modal="false"
    modalPenetrable
    append-to-body
    @open="onOpen"
    @closed="closedModal"
  >
    <template #header>预览视频</template>
    <div style="width: 100%; height: 100%">
      <video
        id="tx-player"
        style="width: 100%; height: 100%"
        preload="auto"
        playsinline
        webkit-playsinline
        @keydown="handleKeyDown"
      ></video>
    </div>
  </draggable-dialog>
</template>

<script setup>
import { getPlayTokenApi } from "@/api/userPlay/index";
import { findTxPlayerInfo } from "@/api/examCenter/exam";
import TCPlayer from "tcplayer.js";
import { ElMessage } from "element-plus";
import { TXLicenseUrl } from "@/constants/index";
import { createPlugins, tcplayerTip } from "@/utils/tcplayerOptions";
import DraggableDialog from "@/components/OnlineWps/draggableDialog.vue";
const visible = defineModel("visible", { default: false });
const props = defineProps({
  videoId: {
    type: String,
    default: "",
  },
  row: {
    type: Object,
    default: () => ({}),
  },
  playMode: {
    type: String,
    default: "",
  },
});

let isTPlay = false; // 是否正在播放
let tPlayer = null;
//默认播放
const defaultTcPlay = () => {
  findTxPlayerInfo({
    videoId: props.videoId,
  }).then((res) => {
    tPlayer = TCPlayer("tx-player", {
      fileID: props.videoId,
      appID: res.data.subAppId,
      psign: res.data.token,
      licenseUrl:
        "https://license.vod2.myqcloud.com/license/v2/1321573871_1/v_cube.license",
      language: "en",
      autoplay: true,
      width: "100%",
      height: "100%",
      playbackRates: [0.8, 1, 1.2, 1.5,1.8, 2],
      languages: {
        en: {
          "360P": "流畅",
          高清: "高清",
          auto: "标清",
        },
      },
      plugins: createPlugins(),
    });

    tPlayer.on("loadstart", () => {});

    tPlayer.on("loadedmetadata", () => {
      tcplayerTip.init(tPlayer);
    });

    // 腾讯视频播放完毕
    tPlayer.on("ended", () => {
      isTPlay = false;
      emit("playEnd");
    });

    // 腾讯视频暂停
    tPlayer.on("pause", () => {
      isTPlay = false;
    });

    // 腾讯播放视频
    tPlayer.on("playing", () => {
      isTPlay = true;
      tcplayerTip.clear(tPlayer);
    });
  });
};
const threeTcPlay = async () => {
  try {
    const { data } = await getPlayTokenApi(props.videoId);
    if (!data || !data.token) {
      return ElMessage({
        type: "error",
        message: "腾讯视频鉴权失败",
      });
    }
    if (!tPlayer) {
      tPlayer = TCPlayer("tx-player", {
        fileID: data.basicInfo.vid || "",
        appID: data.subAppId,
        psign: data.token || "",
        licenseUrl: TXLicenseUrl,
        language: "ZH",
        autoplay: true,
        width: "100%",
        height: "100%",
        playbackRates: [0.8, 1, 1.2, 1.5,1.8, 2],
        languages: {
          ZH: {
            "360P": "流畅",
            高清: "高清",
            auto: "标清",
          },
        },
        plugins: createPlugins(),
      });
      tPlayer.on("loadstart", () => {});

      tPlayer.on("loadedmetadata", () => {
        tcplayerTip.init(tPlayer);
      });

      // 腾讯视频播放完毕
      tPlayer.on("ended", () => {
        isTPlay = false;
        emit("playEnd");
      });

      // 腾讯视频暂停
      tPlayer.on("pause", () => {
        isTPlay = false;
      });

      // 腾讯播放视频
      tPlayer.on("playing", () => {
        isTPlay = true;
        tcplayerTip.clear(tPlayer);
      });
    }
  } catch (error) {}
};
function onOpen() {
  //三个作业
  if (props.row?.quesAnswerMode == "10008" || props.playMode == "threeTcPlay") {
    return threeTcPlay();
  }
  defaultTcPlay();
}

function handleKeyDown(ev) {
  switch (ev.which) {
    case 32: // 空格键
      if (isTPlay) {
        tPlayer.pause();
      } else {
        tPlayer.play();
      }
      break;
    case 39: // 右键(快进)
      const next = tPlayer.currentTime() + 10;
      const timeN = next >= tPlayer.duration() ? tPlayer.duration() : next;
      tPlayer.currentTime(timeN);
      showMsg("播放进度：" + formatSeconds(timeN));
      break;
    case 37: // 左键(快退)
      const prev = tPlayer.currentTime() - 10;
      const timeP = prev <= 0 ? 0 : prev;
      tPlayer.currentTime(timeP);
      showMsg("播放进度：" + formatSeconds(timeP));
      break;
    case 38: // 上
      const upV = parseFloat((tPlayer.volume() + 0.1).toFixed(2));
      const volumeM = upV >= 1 ? 1 : upV;
      tPlayer.volume(volumeM);
      showMsg("音量：" + (volumeM * 100).toFixed(0) + "%");
      break;
    case 40: // 下
      const downV = parseFloat((tPlayer.volume() - 0.1).toFixed(2));
      const volumeD = downV <= 0 ? 0 : downV;
      tPlayer.volume(volumeD);
      showMsg("音量：" + (volumeD * 100).toFixed(0) + "%");
      break;
  }
}

/*
 * 工具方法：格式化秒为时分秒
 */
function formatSeconds(value) {
  let second = parseInt(value),
    minute = 0,
    hour = 0;
  if (second >= 60) {
    minute = parseInt(second / 60);
    second = parseInt(second % 60); //  获取秒数，秒数取佘，得到整数秒数
    if (minute >= 60) {
      hour = parseInt(minute / 60);
      minute = parseInt(minute % 60); //  获取小时后取佘的分，获取分钟除以60取佘的分
    }
  }

  const showS =
    parseInt(second) < 10 ? "0" + parseInt(second) : parseInt(second);
  let result = "0:" + showS;
  if (minute > 0) {
    result = "" + parseInt(minute) + ":" + showS;
  }
  if (hour > 0) {
    const showM =
      parseInt(minute) < 10 ? "0" + parseInt(minute) : parseInt(minute);
    result = "" + parseInt(hour) + ":" + showM + ":" + showS;
  }
  return result;
}

function showMsg(msg) {
  ElMessage.closeAll();
  ElMessage.info({
    appendTo: "#tx-player",
    message: msg,
  });
}

const emit = defineEmits(["update:visible", "refresh", "playEnd"]);

function closedModal() {
  emit("update:visible", false);
  isTPlay = false;
  if (tPlayer != null) {
    tPlayer.pause();
    tPlayer.dispose();
    tPlayer = null;
  }
}

onBeforeUnmount(() => {
  try {
    closedModal();
  } catch (e) {}
});
</script>

<style lang="scss">
.msg-wrapper-txy {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 2147483648;
  background-color: #333;
  border-radius: 8px;
  padding: 8px 12px;
  color: white;
  font-size: 16px;
  line-height: 22px;
  opacity: 0;
  transition: opacity 0.2s linear;
  pointer-events: none;
}

.video-dialog-txy-778yy {
  .el-dialog {
    background-color: transparent;
    box-shadow: none;

    .el-dialog__headerbtn {
      transform: scale(2);
      //position: relative;
      top: -20px;
      right: -20px;
    }
  }
}
</style>
